import { useState } from "react";
import type { Flag } from "@/app/reviewQueries";
import { Button } from "@/ui/Button";
import { riskText } from "./model";

export const CALL_HINT = "отметка живёт только в этой вкладке — приглашение на созвон появится вместе с календарём в SP5";

/** Карточка риска (правило 10 CLAUDE.md): три возврата по одной причине — созвон, не текст.
 *  Бэкенда для приглашения нет: кнопка честно ставит локальную отметку. */
export function RiskCard({ flag }: { flag: Flag }) {
  const [proposed, setProposed] = useState(false);
  return (
    <section className="flex flex-col gap-2.5 rounded-lg border border-warn bg-card px-4 py-3.5" data-testid="risk-card">
      <div className="font-mono text-[10.5px] uppercase tracking-[.06em] text-warn">риск</div>
      <p className="m-0 text-[13px] leading-[1.55] text-ink">{riskText(flag)}</p>
      <Button
        size="sm"
        variant={proposed ? "secondary" : "primary"}
        aria-pressed={proposed}
        className="w-full justify-center"
        title={CALL_HINT}
        onClick={() => setProposed((v) => !v)}
        data-testid="propose-call"
      >
        {proposed ? "✓ созвон предложен" : "предложить созвон"}
      </Button>
      <span className="font-mono text-[11px] leading-[1.45] text-ink2" data-testid="call-hint">
        {proposed ? CALL_HINT : "созвон вместо четвёртого текста: отметка пока локальная"}
      </span>
    </section>
  );
}
